export default __webpack_public_path__ + "static/support-sponsor-command-8805f6127e226252abcb8aa410c357de.png";